import { render } from "./AuthInputLabel.vue?vue&type=template&id=1d53a591"
import script from "./AuthInputLabel.vue?vue&type=script&lang=js"
export * from "./AuthInputLabel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__